import { apiConfig } from '../config/app'

export const CURRENCY = 'UAH'

export const SERVER_BATCH_MAX = 20

export const SERVER_FLUSH_INTERVAL_MS = 2000

export const META_PIXEL_ID: string = process.env.REACT_APP_META_PIXEL_ID ?? ''

/**
 * Compute the analytics events endpoint URL using the same logic as
 * ApiService.getApiRootUrl() in src/services/api.ts (line 79).
 */
export function getServerEndpoint(): string {
  const base = new URL(apiConfig.baseUrl)
  const path = base.pathname.replace(/\/?ecom\/?$/, '/').replace(/\/+$|^\/+/, '/')
  const apiRoot = `${base.origin}${path}`.replace(/\/$/, '')
  return `${apiRoot}/analytics/events`
}
